import React from 'react';

import { MemberRole, MemberStatus } from '@/shared/api/organization';

interface TeamStatusProps {
    role?: MemberRole;
    status?: MemberStatus;
}

export const TeamStatus: React.FC<TeamStatusProps> = ({ role, status }) => {
    if (role) {
        return (
            <span
                className={`px-1.5 py-0.5 min-w-[24px] rounded-lg text-xs font-bold inline-block capitalize ${role === MemberRole.ADMIN ? 'bg-background-lightAccent text-content-accent' : 'bg-background-secondary text-content-primary'}`}
            >
                {role}
            </span>
        );
    }

    if (status) {
        const statusClasses: Record<MemberStatus, string> = {
            active: 'bg-background-lightPositive text-content-positive',
            pending: 'bg-background-lightWarning text-content-warning',
            error: 'bg-background-lightNegative text-content-negative',
            deleted: 'bg-background-gray-300 text-gray-600',
        };

        return (
            <span
                className={`px-1.5 py-0.5 min-w-[24px] rounded-lg text-xs font-bold inline-block capitalize ${statusClasses[status] || ''}`}
            >
                {status}
            </span>
        );
    }

    return null;
};
